import type { TFunction } from 'i18next';

import { fillTranslationPlaceholders } from '../../../utils/helpers/globalBroadcastMessage';

export const DUEL_TEXT: Record<string, string> = {
	T_SITE_DUELS_TITLE: 'Duels',
	T_SITE_DUELS_HERO_TITLE: 'SKILL-BASED',
	T_SITE_DUELS_HERO_TITLE_ACCENT: 'DUELS',
	T_SITE_DUELS_HERO_SUBTITLE: 'Same challenge. Your decisions.',
	T_SITE_DUELS_FEATURE_SAME_TITLE: 'Same challenge',
	T_SITE_DUELS_FEATURE_SAME_BODY: 'Identical setup for all players',
	T_SITE_DUELS_FEATURE_FAIR_TITLE: 'Fair play active',
	T_SITE_DUELS_FEATURE_FAIR_BODY: 'No automation or external help',
	T_SITE_DUELS_FEATURE_CLIMB_TITLE: 'Compete & climb',
	T_SITE_DUELS_FEATURE_CLIMB_BODY: 'Win, improve your rating and earn rewards',
	T_SITE_DUELS_FIND: 'FIND A DUEL',
	T_SITE_DUELS_FINDING: 'FINDING A DUEL…',
	T_SITE_DUELS_RATING: '%% Rating',
	T_SITE_DUELS_NEXT_DIVISION: '%% at %%',
	T_SITE_DUELS_TOP_DIVISION: 'Top division reached',
	T_SITE_DUELS_DAYS_LEFT: '%% days left',
	T_SITE_DUELS_ENDS_TODAY: 'Ends today',
	T_SITE_DUELS_POINTS: '%% pts',
	T_SITE_DUELS_NEXT_MILESTONE: 'Next milestone at %%',
	T_SITE_DUELS_ALL_MILESTONES: 'All milestones reached',
	T_SITE_DUELS_NO_SEASON: 'No season is running',
	T_SITE_DUELS_HISTORY_CARD_TITLE: 'DUEL HISTORY',
	T_SITE_DUELS_HISTORY_CARD_BODY: 'View your past duels and results.',
	T_SITE_DUELS_HISTORY_TITLE: 'Duel History',
	T_SITE_DUELS_IN_PROGRESS: 'DUEL IN PROGRESS',
	T_SITE_DUELS_REMAINING: '%% remaining',
	T_SITE_DUELS_PLAYERS_FINISHED: '%% / %% players finished',
	T_SITE_DUELS_YOUR_RESULT: 'YOUR RESULT',
	T_SITE_DUELS_SCORE_VALUE: '%% Score',
	T_SITE_DUELS_PROVISIONAL: 'PROVISIONAL',
	T_SITE_DUELS_LOCKED_IN: 'Your score is locked in.',
	T_SITE_DUELS_STILL_PLAYING: '%% players are still playing.',
	T_SITE_DUELS_FINAL_WHEN_CLOSES: 'Final results will be available when the Duel closes.',
	T_SITE_DUELS_RUN_IN_PROGRESS: 'Your run is not finished yet.',
	T_SITE_DUELS_VIEW_PROVISIONAL: 'VIEW PROVISIONAL RESULT',
	T_SITE_DUELS_RESUME: 'RESUME DUEL',
	T_SITE_DUELS_PREPARING: 'Preparing your table…',
	T_SITE_DUELS_PREPARING_SLOW: 'This is taking longer than usual.',
	T_SITE_DUELS_RETRY: 'RETRY',
	T_SITE_DUELS_BACK_TO_DUELS: 'BACK TO DUELS',
	T_SITE_DUELS_COMPLETE_TITLE: 'Duel Complete',
	T_SITE_DUELS_GREAT_RUN: 'Great run!',
	T_SITE_DUELS_SCORE: 'Score',
	T_SITE_DUELS_CURRENT_POSITION: 'Current position',
	T_SITE_DUELS_NOT_RANKED: 'Not ranked',
	T_SITE_DUELS_NOT_RANKED_BODY: 'Your run did not qualify for ranking.',
	T_SITE_DUELS_LEADERBOARD_PROVISIONAL: 'LEADERBOARD (PROVISIONAL)',
	T_SITE_DUELS_YOU: 'You',
	T_SITE_DUELS_VIEW_BREAKDOWN: 'VIEW SCORE BREAKDOWN',
	T_SITE_DUELS_SETTLED_TITLE: 'Duel Settled',
	T_SITE_DUELS_YOU_FINISHED: 'You finished',
	T_SITE_DUELS_DUEL_SCORE: 'Duel Score',
	T_SITE_DUELS_DUEL_RATING: 'Duel Rating',
	T_SITE_DUELS_SEASON_POINTS: 'Season Points',
	T_SITE_DUELS_SETTLING: 'Final results are being applied…',
	T_SITE_DUELS_REWARDS_OBTAINED: 'Rewards Obtained',
	T_SITE_DUELS_REWARD_CHIPS: '%% Chips',
	T_SITE_DUELS_REWARD_XP: '%% XP',
	T_SITE_DUELS_REWARD_VIP_DAYS: '%% VIP days',
	T_SITE_DUELS_SEASON_MILESTONE: 'Season Milestone',
	T_SITE_DUELS_MILESTONE_UNLOCKED: '%% Unlocked',
	T_SITE_DUELS_MILESTONE_REACHED: 'You have reached the %% Season Points milestone.',
	T_SITE_DUELS_PERSONAL_BEST: 'New personal best!',
	T_SITE_DUELS_BREAKDOWN_TITLE: 'Score Breakdown',
	T_SITE_DUELS_FINAL_SCORE: 'Final Score',
	T_SITE_DUELS_FINAL_POSITION: 'Final Position',
	T_SITE_DUELS_POSITION_OF: '/ %% players',
	T_SITE_DUELS_SCORE_SOURCES: 'SCORE SOURCES',
	T_SITE_DUELS_SOURCE_OUTCOME: 'Hand Results',
	T_SITE_DUELS_SOURCE_OUTCOME_BODY: 'Points from the hands you played',
	T_SITE_DUELS_SOURCE_DECISIONS: 'Decision Quality',
	T_SITE_DUELS_SOURCE_DECISIONS_BODY: 'How well you chose each move',
	T_SITE_DUELS_SOURCE_RISK: 'Risk Management',
	T_SITE_DUELS_SOURCE_RISK_BODY: 'How well you managed your bets',
	T_SITE_DUELS_SOURCE_TIME: 'Time Bonus',
	T_SITE_DUELS_SOURCE_TIME_BODY: 'For deciding quickly',
	T_SITE_DUELS_TOTAL_SCORE: 'TOTAL SCORE',
	T_SITE_DUELS_ADDITIONAL_INFO: 'ADDITIONAL INFO',
	T_SITE_DUELS_RUN_DURATION: 'Run Duration',
	T_SITE_DUELS_DURATION: '%% min %% sec',
	T_SITE_DUELS_HANDS_PLAYED: 'Hands Played',
	T_SITE_DUELS_PLAYERS_IN_DUEL: 'Players in Duel',
	T_SITE_DUELS_COMPLETED_AT: 'Completed At',
	T_SITE_DUELS_TAB_ALL: 'All',
	T_SITE_DUELS_TAB_THIS_SEASON: 'This Season',
	T_SITE_DUELS_TAB_PREVIOUS_SEASON: 'Previous Season',
	T_SITE_DUELS_ALL_TYPES: 'All Types',
	T_SITE_DUELS_PLAYERS: '%% players',
	T_SITE_DUELS_POSITION: 'Position',
	T_SITE_DUELS_RATING_LABEL: 'Rating',
	T_SITE_DUELS_REWARDS: 'Rewards',
	T_SITE_DUELS_SETTLED_BADGE: 'Settled',
	T_SITE_DUELS_HISTORY_EMPTY: 'No duels here yet.',
	T_SITE_DUELS_CONNECTING: 'Connecting…',
	T_SITE_DUELS_OPENED_ELSEWHERE: 'Duels were opened on another device or tab.',
	T_SITE_DUELS_RECONNECT: 'RECONNECT',
	T_SITE_DUELS_OK: 'OK',
	T_SITE_DUELS_ERROR_LOAD: 'Duels could not be loaded. Please try again.',
	T_SITE_DUELS_ERROR_UNAVAILABLE: 'Duels are not available right now.',
	T_SITE_DUELS_ERROR_JOIN_FAILED: 'Could not join a duel. Please try again.',
	T_SITE_DUELS_ERROR_JOIN_TIMEOUT: 'Joining took too long. Please try again.',
	T_SITE_DUELS_ERROR_JOIN_REFUSED: 'You cannot join a duel right now.',
	T_SITE_DUELS_ERROR_MATCHMAKING_UNAVAILABLE: 'Matchmaking is unavailable. Please try again later.',
	T_SITE_DUELS_ERROR_MATCHMAKING_BUSY: 'Matchmaking is busy. Please try again in a moment.',
	T_SITE_DUELS_ERROR_TYPE_NOT_AVAILABLE: 'This duel is not available right now.',
	T_SITE_DUELS_ERROR_RESULT_NOT_FOUND: 'This duel result is not available.',
	T_SITE_DUELS_SEASON_TITLE: 'Duel Season',
	T_SITE_DUELS_SEASON_TAGLINE:
		'Compete in skill-based duels, climb the ranks and earn exclusive rewards.',
	T_SITE_DUELS_PERCENT_COMPLETED: '%% completed',
	T_SITE_DUELS_STATUS_RECEIVED: 'RECEIVED',
	T_SITE_DUELS_STATUS_ON_ITS_WAY: 'ON ITS WAY',
	T_SITE_DUELS_STATUS_CONTACT_SUPPORT: 'CONTACT SUPPORT',
	T_SITE_DUELS_REQUEST: 'REQUEST',
	T_SITE_DUELS_REWARDS_WAITING: 'You still have rewards to request.',
	T_SITE_DUELS_OPEN_REWARDS: 'OPEN REWARDS',
	T_SITE_DUELS_REWARD_STATUS_UNLOCKED: 'Unlocked',
	T_SITE_DUELS_REWARD_STATUS_GRANTED: 'Received',
	T_SITE_DUELS_REWARD_STATUS_REQUESTED: 'Requested',
	T_SITE_DUELS_REWARD_STATUS_UNDER_REVIEW: 'Under Review',
	T_SITE_DUELS_REWARD_STATUS_APPROVED: 'Approved',
	T_SITE_DUELS_REWARD_STATUS_REJECTED: 'Rejected',
	T_SITE_DUELS_REWARD_STATUS_FULFILLED: 'Fulfilled',
	T_SITE_DUELS_REWARD_STATUS_FAILED: 'Failed',
	T_SITE_DUELS_REWARD_STATUS_CANCELLED: 'Cancelled',
	T_SITE_DUELS_REWARD_STATUS_EXPIRED: 'Expired',
	T_SITE_DUELS_REWARD_ERROR_NOT_CLAIMABLE: "This reward can't be claimed.",
	T_SITE_DUELS_CLAIM: 'CLAIM',
	T_SITE_DUELS_CLAIMED: 'CLAIMED',
	T_SITE_DUELS_REWARD_STATUS_CLAIMED: 'Claimed',
	T_SITE_DUELS_REWARDS_CLAIMED: 'Rewards claimed: %%',
	T_SITE_DUELS_REWARDS_TO_CLAIM: 'Rewards from earlier seasons to claim',
	T_SITE_DUELS_VIEW_ALL_REWARDS: 'View all rewards (%%)',
	T_SITE_DUELS_SHOW_LESS: 'Show less',
	T_SITE_DUELS_HOME_CLAIM_REWARD: 'CLAIM REWARD',
	T_SITE_DUELS_MISSION_PROGRESS: 'Mission Progress',
	T_SITE_DUELS_DATE: 'Date',
	T_SITE_DUELS_NOW: 'Now %%',
	T_SITE_DUELS_REWARD_DETAILS_TITLE: 'REWARD DETAILS',
	T_SITE_DUELS_REWARD_UNLOCKED_BY: 'You unlocked this by reaching %% Season Points in %%.',
	T_SITE_DUELS_ROW_MILESTONE: 'Milestone',
	T_SITE_DUELS_ROW_SEASON: 'Season',
	T_SITE_DUELS_ROW_REQUEST_BY: 'Request by',
	T_SITE_DUELS_ROW_STATUS: 'Status',
	T_SITE_DUELS_ROW_REQUEST_ID: 'Request ID',
	T_SITE_DUELS_ROW_REQUESTED: 'Requested',
	T_SITE_DUELS_SEASON_POINTS_VALUE: '%% Season Points',
	T_SITE_DUELS_REWARD_INFO:
		'This reward isn’t issued automatically. Submit a request and our team checks eligibility before fulfilling it. Subject to eligibility and market rules.',
	T_SITE_DUELS_REQUEST_REWARD: 'REQUEST REWARD',
	T_SITE_DUELS_CANCEL_REQUEST: 'CANCEL REQUEST',
	T_SITE_DUELS_YOUR_DETAILS: 'YOUR DETAILS',
	T_SITE_DUELS_FULL_NAME: 'Full name',
	T_SITE_DUELS_FULL_NAME_HINT: 'As it should appear on the reward.',
	T_SITE_DUELS_EMAIL: 'Email for delivery',
	T_SITE_DUELS_EMAIL_HINT: 'We’ll send the reward here.',
	T_SITE_DUELS_CONFIRM: 'I confirm these details are correct and accept the Reward Terms.',
	T_SITE_DUELS_REQUEST_INFO:
		'Our team reviews every request and may contact you if more information is needed. One request per milestone.',
	T_SITE_DUELS_SUBMIT_REQUEST: 'SUBMIT REQUEST',
	T_SITE_DUELS_CHOOSE_METHOD: 'CHOOSE REWARD METHOD',
	T_SITE_DUELS_METHOD_PAYPAL: 'PayPal',
	T_SITE_DUELS_METHOD_PAYPAL_HINT: 'Receive via PayPal account',
	T_SITE_DUELS_METHOD_GIFT_CARD: 'Gift Card',
	T_SITE_DUELS_METHOD_GIFT_CARD_HINT: 'Receive a digital gift card',
	T_SITE_DUELS_METHOD_VOUCHER: 'Voucher',
	T_SITE_DUELS_METHOD_VOUCHER_HINT: 'Receive a Svara voucher',
	T_SITE_DUELS_ACCOUNT_DETAILS: 'ACCOUNT DETAILS',
	T_SITE_DUELS_EMAIL_PAYPAL: 'PayPal email address',
	T_SITE_DUELS_EMAIL_GIFT_CARD: 'Email for the gift card',
	T_SITE_DUELS_EMAIL_VOUCHER: 'Email for the voucher',
	T_SITE_DUELS_ACCOUNT_INFO:
		'Please make sure your details are correct. Our team will review your request and may contact you if additional information is required.',
	T_SITE_DUELS_ROW_REWARD: 'Reward',
	T_SITE_DUELS_ROW_REWARD_TYPE: 'Reward type',
	T_SITE_DUELS_ROW_VALUE: 'Value',
	T_SITE_DUELS_ROW_METHOD: 'Method',
	T_SITE_DUELS_ROW_EMAIL: 'Email',
	T_SITE_DUELS_REAL_WORLD_REWARD: 'Real-World Reward',
	T_SITE_DUELS_SUBMITTED_REWARD_BODY: 'Your %% request has been sent and is now under review.',
	T_SITE_DUELS_REQUEST_NOW: 'REQUEST NOW',
	T_SITE_DUELS_SEE_ALL: 'See all',
	T_SITE_DUELS_PAGE_REWARD_DETAILS: 'Reward Details',
	T_SITE_DUELS_PAGE_REQUEST_REWARD: 'Request Reward',
	T_SITE_DUELS_PAGE_REWARD_REQUEST: 'Reward Request',
	T_SITE_DUELS_PAGE_REDEMPTION_HISTORY: 'Redemption History',
	T_SITE_DUELS_NEW: 'NEW',
	T_SITE_DUELS_ERROR_NAME: 'Enter your full name (2–120 characters).',
	T_SITE_DUELS_ERROR_EMAIL: 'Enter a valid email address.',
	T_SITE_DUELS_ERROR_CONFIRM: 'Please confirm your details.',
	T_SITE_DUELS_SUBMITTED_TITLE: 'REQUEST SUBMITTED',
	T_SITE_DUELS_SUBMITTED_HEADLINE: 'Request submitted!',
	T_SITE_DUELS_SUBMITTED_BODY:
		'We’ve received your request. It moves to Under Review when our team picks it up.',
	T_SITE_DUELS_SUBMITTED_INFO:
		'We’ll notify you whenever the status changes. You can track it in Inventory › Rewards.',
	T_SITE_DUELS_VIEW_IN_INVENTORY: 'VIEW IN INVENTORY',
	T_SITE_DUELS_REQUEST_DETAILS_TITLE: 'REQUEST DETAILS',
	T_SITE_DUELS_STATUS_SECTION: 'STATUS',
	T_SITE_DUELS_STATUS_INFO_REQUESTED: 'You submitted a request. Our team will review it soon.',
	T_SITE_DUELS_STATUS_INFO_UNDER_REVIEW: 'An authorized team member is checking eligibility.',
	T_SITE_DUELS_STATUS_INFO_APPROVED: 'Approved and being prepared.',
	T_SITE_DUELS_STATUS_INFO_REJECTED:
		'This request was not approved. If you think this is a mistake, contact support with your Request ID.',
	T_SITE_DUELS_STATUS_INFO_FULFILLED:
		'Your reward was delivered. Can’t find it? Check your spam folder, then contact support with your Request ID.',
	T_SITE_DUELS_STATUS_INFO_FAILED: 'Delivery didn’t go through — our team will follow up.',
	T_SITE_DUELS_STATUS_INFO_CANCELLED: 'This request was cancelled.',
	T_SITE_DUELS_STATUS_INFO_EXPIRED: 'The request window for this reward has closed.',
	T_SITE_DUELS_REWARD_ERROR: 'Something went wrong. Please try again.',
	T_SITE_DUELS_REWARD_ERROR_WINDOW_CLOSED: 'The request window for this reward has closed.',
	T_SITE_DUELS_REWARD_ERROR_LIMIT: 'This reward has reached its request limit.',
	T_SITE_DUELS_REWARD_ERROR_NOT_REQUESTABLE: 'This reward can’t be requested right now.',
	T_SITE_DUELS_REWARD_ERROR_DETAILS: 'Please check your details.',
	T_SITE_DUELS_REWARD_ERROR_BUSY: 'Please try again in a moment.',
	T_SITE_DUELS_REWARD_ERROR_NOT_FOUND: 'This reward is no longer available.',
	T_SITE_DUELS_REWARD_ERROR_INELIGIBLE:
		'Your account isn’t eligible for this reward right now. Contact support for help.',
	T_SITE_DUELS_REWARD_ERROR_STATUS_CHANGED: 'This request has already moved on.',
	T_SITE_DUELS_REWARD_SEASON_LINE: '%% · %% Season Points',
	T_SITE_DUELS_REDEMPTION_HISTORY: 'REDEMPTION HISTORY',
	T_SITE_DUELS_REWARDS_EMPTY:
		'Reach high Season Point milestones in Duels to unlock real-world rewards.',
	T_SITE_DUELS_CURRENT_SEASON: 'Current Season',
	T_SITE_DUELS_PREVIOUS_SEASONS: 'Previous Seasons',
	T_SITE_DUELS_SEASON_PTS: 'Season Pts',
	T_SITE_DUELS_FINAL_STANDINGS: '%% · final standings',
	T_SITE_DUELS_STANDINGS_PENDING: '%% · standings being finalised',
	T_SITE_DUELS_YOUR_POSITION: 'Your position: #%%',
	T_SITE_DUELS_RANKING_EMPTY: 'No players ranked yet.',
	T_SITE_DUELS_NO_PREVIOUS_SEASON: 'No season has ended yet.',
	T_SITE_DUELS_RANKING_LOGIN_REQUIRED: 'Log in to see the duel rankings.',
	T_SITE_DUELS_DIVISION_RATING: '%% · %% Rating',
	T_SITE_DUELS_PROFILE_LABEL: 'DUEL',
	T_SITE_DUELS_WINS: 'WINS',
	T_SITE_DUELS_HOME_REWARD_UNLOCKED: 'REWARD UNLOCKED',
	T_SITE_DUELS_HOME_UNDER_REVIEW: 'UNDER REVIEW',
	T_SITE_DUELS_HOME_REWARD_SENT: 'REWARD SENT',
	T_SITE_DUELS_HOME_IN_PROGRESS: 'DUEL IN PROGRESS',
	T_SITE_DUELS_HOME_RESULT_IN: 'RESULT IN %%',
	T_SITE_DUELS_HOME_DUEL_READY: '1 DUEL READY',
	T_SITE_DUELS_HOME_TO_NEXT: '%% TO %%',
	T_SITE_DUELS_UNIT_HOURS: '%%H',
	T_SITE_DUELS_UNIT_MINUTES: '%%M',
	T_SITE_DUELS_HUD_DUEL: 'DUEL',
	T_SITE_DUELS_HUD_IN_PROGRESS: 'In progress',
	T_SITE_DUELS_HUD_PLAYERS: 'players',
	T_SITE_DUELS_HUD_LEFT: 'left',
	T_SITE_DUELS_HUD_HISTORY: 'History',
	T_SITE_DUELS_HUD_RUN_TITLE: 'YOUR RUN IS',
	T_SITE_DUELS_HUD_RUN_LIVE: 'LIVE',
	T_SITE_DUELS_HUD_PLAYING: 'PLAYING',
	T_SITE_DUELS_HUD_RUN_BODY:
		'Complete your run. Your score locks when you finish, then is compared with other players in the same challenge pool.',
	T_SITE_DUELS_HUD_FINISHED: 'Finished',
	T_SITE_DUELS_HUD_STILL_PLAYING: 'Still playing',
	T_SITE_DUELS_HUD_TRUST: 'Same challenge · Server-validated',
	T_SITE_DUELS_HUD_TRUST_INFO:
		'Everyone in this pool plays the same deals, and every score is calculated on the server.',
	T_SITE_DUELS_HUD_LEAVE: 'LEAVE DUEL',
	T_SITE_DUELS_HUD_LEAVE_TITLE: 'Leave the duel?',
	T_SITE_DUELS_HUD_LEAVE_BODY: 'Your run ends now and your current score is locked in.',
	T_SITE_DUELS_HUD_LEAVE_CONFIRM: 'Leave',
	T_SITE_DUELS_HUD_LEAVE_FAILED: 'Could not leave the duel. Try again.',
	T_SITE_DUELS_RESULT_RUN_COMPLETE: 'RUN COMPLETE',
	T_SITE_DUELS_RESULT_PROVISIONAL: 'PROVISIONAL RESULT',
	T_SITE_DUELS_RESULT_FINAL: 'FINAL RESULT',
	T_SITE_DUELS_RESULT_CONFIRM_NOTE: 'Final position and rewards confirm after settlement.',
	T_SITE_DUELS_RESULT_FINAL_NOTE: 'Your final position and rewards are confirmed.',
	T_SITE_DUELS_RESULT_PLAYER: 'Player',
	T_SITE_DUELS_RESULT_BREAKDOWN: 'SCORE BREAKDOWN (THIS RUN)',
	T_SITE_DUELS_RESULT_PROGRESSION: 'PROGRESSION',
	T_SITE_DUELS_RESULT_DIVISION: 'Division',
	T_SITE_DUELS_RESULT_PENDING: 'Pending',
	T_SITE_DUELS_RESULT_UNRANKED: 'No rating change in unranked duels',
	T_SITE_DUELS_RESULT_RETURN_LOBBY: 'RETURN TO LOBBY',
	T_SITE_DUELS_RESULT_VIEW_SETTLED: 'VIEW SETTLED RESULT',
};

export const duelText = (t: TFunction, key: string, values: (string | number)[] = []) => {
	const text = t(key, { defaultValue: DUEL_TEXT[key] ?? key });
	return values.length ? fillTranslationPlaceholders(text, values.map(String)) : text;
};
